export const NITRO_BREW_AGENT_ROLE = 'autopilot';
